import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { obtenerArchivos } from "../AccionesBackend";
import { VisualizadorPdfs } from "./VisualizadorPdfs";
import { BotonRegresar } from "../BotonRegresar";

export const NormasConducta = () => {
    const [archivos, setArchivos] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchArchivos = async () => {
            try {
                const response = await obtenerArchivos({ seccionId: 7 });
                if (response && response.success) {
                    if (response.archivos && response.archivos.length > 0) {
                        const mappedFiles = response.archivos.map(file => ({
                            src: file.ruta_archivo,
                            title: file.nombre_archivo,
                        }));
                        setArchivos(mappedFiles);
                    } else {
                        setError("No se encontraron archivos.");
                    }
                } else {
                    setError("Error al obtener los archivos.");
                }
            } catch (err) {
                setError("Error al cargar datos.");
            }
        };

        fetchArchivos();
    }, []);

    return (
        <section className="normas-conducta">
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar />
                    <h1>Normas de conducta</h1>
                </div>
                {error ? (
                    <p style={{ textAlign: "center", padding: "20px", color: "red" }}>{error}</p>
                ) : (
                    <VisualizadorPdfs initialPdfs={archivos} />
                )}
            </Container>
        </section>
    );
};
